<template>
  <dialog-layout>
    <!--Confirm Email Address-->
    <template v-if="showConfirmEmailForm">
      <confirm-email :email="email" :sendCode="true" @confirm="handleEmailConfirmed"></confirm-email>
    </template>

    <!--Reset Password Form-->
    <template v-else>
      <h1 class="title is-h1">Password Reset</h1>

      <!--Reset Password Form-->
      <template v-if="showPasswordResetForm">
        <div class="notification is-succes">
          <p>
            <i class="fa fa-envelope"></i> We have sent a password reset code to <strong>{{ email }}</strong>.
            It may take a couple of minutes to arrive, and be sure to check your junk mail folder, just in case.
            <a @click="showPasswordResetForm = false">Resend code.</a>
          </p>
        </div>
        <div class="notification is-danger" v-if="passwordSubmitError">
          {{ passwordSubmitError }}
        </div>
        <p>
          Once you receive the code, enter it below to reset your password.
        </p>
        <form @submit.prevent="handlePasswordReset">
          <b-field label="Password Reset Code">
            <b-input :required="true" v-model.trim="code"></b-input>
          </b-field>
          <b-field label="New Password">
            <b-input type="password" :required="true" v-model.trim="password"></b-input>
          </b-field>
          <button type="submit" class="button is-primary" :disabled="isLoading">Reset Password</button>
          <p>
            <router-link :to="{ name: 'login' }">Back to Login Page</router-link>
          </p>
        </form>
      </template>

      <!--Forgot Password Request Form-->
      <template v-else>
        <div class="notification is-danger" v-if="emailSubmitError">
          {{ emailSubmitError }}
        </div>
        <p>Enter the email associated with your account, and we will send you a code to reset your password.</p>
        <form @submit.prevent="handleSubmitEmail">
          <b-field label="Email">
            <b-input type="email" :required="true" v-model.trim="email"></b-input>
          </b-field>
          <button type="submit" class="button is-primary" :disabled="isLoading">Submit</button>
          <p>
            <router-link :to="{ name: 'login' }">Back to Login Page</router-link>
          </p>
        </form>
      </template>
    </template>

  </dialog-layout>
</template>

<script>
import DialogLayout from '../layouts/DialogLayout.vue'
import ConfirmEmail from '../components/auth/ConfirmEmail'

export default {
  components: {
    DialogLayout,
    ConfirmEmail
  },
  data () {
    return {
      email: '',
      code: '',
      password: '',
      emailSubmitError: null,
      passwordSubmitError: null,
      showPasswordResetForm: false,
      showConfirmEmailForm: false,
      isLoading: false
    }
  },
  methods: {
    handleSubmitEmail () {
      this.isLoading = true
      this.emailSubmitError = null
      // send the request
      this.$cognito.forgotPassword(this.email)
        .then(() => {
          this.showPasswordResetForm = true
        })
        .catch((error) => {
          // if this error was because the user's email isn't confirmed, show that form
          if (error.code === 'InvalidParameterException') {
            if (error.message === 'Cannot reset password for the user as there is no registered/verified email or phone_number') {
              // show form to verify email address

            } else {
              // show form to confirm account
              this.showConfirmEmailForm = true
            }
            return
          }
          this.emailSubmitError = error.message
        })
        .then(() => {
          this.isLoading = false
        })
    },
    handlePasswordReset () {
      this.isLoading = true
      this.passwordSubmitError = null
      // reset the password
      this.$cognito.resetPassword(this.email, this.code, this.password)
        .then(async () => {
          // login the user
          await this.$cognito.login(this.email, this.password)
          // send to the homepage
          this.$router.push({ name: 'home' })
        })
        .catch((error) => {
          this.passwordSubmitError = error.message
        })
        .then(() => {
          this.isLoading = false
        })
    },
    handleEmailConfirmed () {
      // re-attempt submitting the forgot password
      this.handleSubmitEmail()
    }
  }
}
</script>
